module.exports = __webpack_public_path__ + "static/media/home_tunnel_7.26b1acfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_7.png
// module id = 118
// module chunks = 0